import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PrivacyPolicy } from '@mtrx/ui'
import './index.css'
import { privacyConfig, privacyTheme } from './data/privacyConfig'

// Standalone MPA entry — no router, no site chrome, no heavy visuals. A legal
// page is text, and pulling in the home page's bundles buys it nothing.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <PrivacyPolicy config={privacyConfig} theme={privacyTheme} homeHref="/" />
  </StrictMode>
)
